import { useCallback, useMemo } from "react";
import { useConfigurationContext } from "@/components/atomic-crm/root/ConfigurationContext";
import {
  leadStatusColor,
  normalizeLeadStatuses,
  type LeadStatusDef,
} from "../domain/leads/leadStatusModel";

/** The configured lead statuses in their order (config.leadStatuses, normalised; the defaults until it loads). */
export const useLeadStatuses = (): LeadStatusDef[] => {
  const { leadStatuses } = useConfigurationContext();
  return useMemo(() => normalizeLeadStatuses(leadStatuses), [leadStatuses]);
};

/** The colour of a status value (a value the list lacks: neutral grey). */
export const useLeadStatusColor = () => {
  const statuses = useLeadStatuses();
  return useCallback(
    (value: string) => leadStatusColor(statuses, value),
    [statuses],
  );
};
